import { cn } from '~/chords/lib/cn';

export const OVERLAY_CLASS = {
  show: cn('animate-dialog-overlay-show'),
  hide: cn('animate-dialog-overlay-hide'),
} as const;

export const CONTENT_CLASS = {
  show: cn('animate-dialog-content-show'),
  hide: cn('animate-dialog-content-hide'),
  disable: cn('!pointer-events-none'),
} as const;
